import { useFindMatchesAndMismatches } from '../../hooks';
import { TagList } from '../tag-list';

type ListType = 'matched' | 'all';

type Props = {
  type: ListType;
  personalities: {
    __typename?: 'PersonalityTag';
    id: number;
    name: string;
  }[];
  userPersonalityIds: number[];
  maxCount?: number;
};

export const PersonalityTagList = ({
  type,
  personalities,
  userPersonalityIds,
  maxCount,
}: Props) => {
  const { matches, mismatches } = useFindMatchesAndMismatches(
    personalities,
    userPersonalityIds
  );

  let combined = [...matches, ...mismatches];
  if (maxCount) {
    combined = combined.slice(0, maxCount);
  }

  const rawTags = type === 'matched' ? matches : combined;
  const tags = rawTags.map((tag) => ({
    key: tag.id,
    name: tag.name,
    isMatched: tag.isMatched,
  }));

  return <TagList tags={tags} />;
};
